import { Component, Input } from "@angular/core";
import { MaintenanceLogDto } from "app/models";

@Component({
    selector: 'maintenance-log',
    templateUrl: './maintenance-log.component.html',
    styleUrls: ['./maintenance-log.component.scss'],
})
export class MaintenanceLog {
    private val: MaintenanceLogDto
    
    @Input() 
    set value(value: MaintenanceLogDto) {
        this.val = value;
    }

    get value(): MaintenanceLogDto {
        return this.val;
    }
}